import { F0Box } from '@factorialco/f0-react'
import DiscoverBanner from 'modules/ai_reports/components/DiscoverBanner'
import DiscoverCards from 'modules/ai_reports/components/DiscoverCards'
import DiscoverCardsHeader from 'modules/ai_reports/components/DiscoverCardsHeader'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DiscoverPage = () => (
  <ResponsivePage.Body variant="fullscreen">
    <F0Box display="flex" flexDirection="column" padding="xl">
      <DiscoverBanner />
    </F0Box>
    <F0Box display="flex" flexDirection="column" padding="xl">
      <DiscoverCardsHeader />
    </F0Box>
    <F0Box display="flex" flexDirection="column" paddingX="sm" paddingBottom="xl" gap="lg">
      <DiscoverCards />
    </F0Box>
  </ResponsivePage.Body>
)

export default DiscoverPage
